var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewIconBlack = function SvgViewIconBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 0C5.6 0 1.61467 2.90267 0 7C1.61467 11.0973 5.6 14 10.2667 14C14.9333 14 18.9187 11.0973 20.5333 7C18.9187 2.90267 14.9333 0 10.2667 0ZM10.2667 11.6667C7.69067 11.6667 5.6 9.576 5.6 7C5.6 4.424 7.69067 2.33333 10.2667 2.33333C12.8427 2.33333 14.9333 4.424 14.9333 7C14.9333 9.576 12.8427 11.6667 10.2667 11.6667ZM10.2667 4.2C8.71733 4.2 7.46667 5.45067 7.46667 7C7.46667 8.54933 8.71733 9.8 10.2667 9.8C11.816 9.8 13.0667 8.54933 13.0667 7C13.0667 5.45067 11.816 4.2 10.2667 4.2Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewIconBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewIconBlack.5651a98e.svg";
export { ForwardRef as ReactComponent };